import api from "./api";

export interface Documentacao {
  id: number;
  _id: number;
  title: string;
  text: string;
  created_at: string;
  updated_at: string;
}

async function list(): Promise<Documentacao[]> {
  try {
    const { data } = await api.get(`/documentacoes/`);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("Erro ao listar documentações:", e);
    return [];
  }
}

async function getById(id: string | number): Promise<Documentacao | null> {
  try {
    const { data } = await api.get(`/documentacoes/${id}/`);
    return data;
  } catch (e) {
    console.error("Erro ao buscar documentação:", e);
    return null;
  }
}

export interface CreateDocumentacaoPayload {
  title: string;
  text: string;
}

export interface UpdateDocumentacaoPayload {
  title?: string;
  text?: string;
}

async function create(
  payload: CreateDocumentacaoPayload
): Promise<Documentacao | null> {
  try {
    const { data } = await api.post(`/documentacoes/`, payload);
    return data;
  } catch (e) {
    console.error("Erro ao criar documentação:", e);
    return null;
  }
}

async function update(
  id: string | number,
  payload: UpdateDocumentacaoPayload
): Promise<Documentacao | null> {
  try {
    const { data } = await api.put(`/documentacoes/${id}/`, payload);
    return data;
  } catch (e) {
    console.error("Erro ao atualizar documentação:", e);
    return null;
  }
}

const documentacoes = {
  list,
  getById,
  create,
  update,
};

export default documentacoes;
